module.exports = __webpack_public_path__ + "static/media/md-bookmark.4079d6cc.svg";